/**
 * Created by Carsten Bühler
 * User: CBuehler on 01.04.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { translation } from 'plugin/liferay-widgets-react-web';
import TimeLineItem from './TimeLineItem';
import TimeLineItemMessageHeader from './TimeLineItemMessageHeader';
import BusinessObjectLink from '../BusinessObjectLink';
import { ClassNames, EVENT_TYPE_CREATE, EVENT_TYPE_DELETE } from '../../constants/Constants';
import { getEventType } from '../../utils/event-type-util';

const assetEntryFromChange = (changes, nr, isDelete) => {
    const p = isDelete ? 'oldValue' : 'newValue';
    return ['title', 'className', 'classPK', 'description', 'groupId', 'url'].reduce((o, prop) => {
        let v = changes[prop + nr];
        if (v && (v = v[p])) {
            o[prop] = prop === 'classPK' || prop === 'groupId' ? parseInt(v) : v;
        }
        return o;
    }, {});
};

const DocElement = ({ asset }) => (
    <span>
        Dokument{' '}
        <a
            className="btn btn-outline-info btn-sm"
            href={asset.url} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            {asset.title}
        </a>
        {' '}
    </span>);
const BomElement = (({ asset }) => {
    return (
        <React.Fragment>
            {translation.trans(asset.className) + ' '}
            <BusinessObjectLink
                className={asset.className}
                classPK={asset.classPK} title={asset.title}
            />
        </React.Fragment>
    );
});

const AssetLinkChangeRecordRenderer = ({ changeRecord, userMeta }) => {
    const { changes, attachedClassName, attachedClassPK } = changeRecord;
    const eventType = getEventType(changeRecord);
    const isDelete = eventType === EVENT_TYPE_DELETE;
    if (!isDelete && eventType !== EVENT_TYPE_CREATE) {
        console.error('Unknown AssetLink eventType ', changeRecord);
    }

    const asset1 = assetEntryFromChange(changes, 1, isDelete);
    const asset2 = assetEntryFromChange(changes, 2, isDelete);
    const FromElem = asset1.className === ClassNames.DLFileEntry ? DocElement : BomElement;
    const ToElem = asset2.className === ClassNames.DLFileEntry ? DocElement : BomElement;

    return (
        <TimeLineItem userMeta={userMeta} timestamp={changeRecord.timestamp}>
            <TimeLineItemMessageHeader>
                <strong>
                    Verlinkung für{' ' + translation.trans(attachedClassName) + ' '}
                    <BusinessObjectLink className={attachedClassName} classPK={attachedClassPK}/>{' '}
                </strong>

            </TimeLineItemMessageHeader>
            <div className="my-3">
                <span>Verlinkung von <FromElem asset={asset1}/> mit <ToElem
                    asset={asset2}/> {isDelete ? 'entfernt' : 'erstellt'} </span>
            </div>
        </TimeLineItem>

    );
};

AssetLinkChangeRecordRenderer.propTypes = {
    changeRecord: PropTypes.object,
    userMeta: PropTypes.object
};

export default AssetLinkChangeRecordRenderer;



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/AssetLinkChangeRecordRenderer.jsx